<template>
  <div class="commonPadding bgShop">
    <div class="van-row--flex van-clearfix inputTop">
      <div class="flexOne s_input">
        <img src="@/assets/img/search_icon_1.png"
             alt=""
             class="search_icon">
        <van-field class="searchInput"
                   placeholder="请输入关键词"
                   readonly
                   @click="goSearch" />
      </div>
      <div class="car" v-if="k800==0">
        <img src="@/assets/img/maeket_icon_poket@2x.png"
             alt=""
             class="carIcon"
             @click="shopCart">
      </div>
    </div>
    <div class="inputTopWrap"></div>
    <div class="linePo"></div>
    <!-- 下面注释主要，勿删 -->
    <div class="allPart">
      <div v-if="goodsList.length > 0"
           class="van-clearfix">
        <van-pull-refresh v-model="isDownLoading"
                          @refresh="onDownRefresh">
          <van-list v-model="isUpLoading"
                    :finished="upFinished"
                    :immediate-check="false"
                    :offset="offset"
                    finished-text=""
                    @load="onLoadList">
            <ul class="newsUl van-clearfix"
                v-if="goodsList.length > 0">
              <li class="actLi"
                  v-for="(item,index) in goodsList"
                  :key="index"
                  @click="goodDetail(item)">
                <div class="van-clearfix flexBetween box">
                  <div class="imgBox flexCenter">
                    <img :src="baseImg + item.thumbnail" alt="" class="imgPic" @load="activityLoad (item.thumbnail, index)" v-show="item.thumbnail && loadingImges[index]">
                    <img src="@/assets/img/iv_placeholder@2x.png" v-show="!item.thumbnail || !loadingImges[index]">
                  </div>

                  <div>
                    <div class="proName">
                      <div class="pro_sku">
                        {{item.name}}
                        <!--                        电子血压计U10上臂式家用全自动-->
                      </div>
                    </div>
                    <div class="pricePart">
                      <!--                      <span class="unit">￥</span><span class="priceValue">{{item.visitCount}}</span>-->
                      <span class="unit">￥</span><span class="priceValue">{{item.salesPrice}}</span>
                    </div>
                    <div class="salesVolume">销量：{{item.salesVolume}}</div>
                    <!--                    <div class="buyBtn">-->
                    <!--                      立即购买-->
                    <!--                    </div>-->
                  </div>

                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else>
        <img src="@/assets/img/iv_error1@2x.png"
             class="noAct" />
        <div class="actText">暂无商品内容~~</div>
      </div>
    </div>
<!--    <div class="occupie"></div>-->
<!--    <div class="bottomTab">-->
<!--      <div class="flex">-->
<!--        <div class="flexOne">-->
<!--          <img src="@/assets/img/tabbar_home_nor.png"-->
<!--               alt=""-->
<!--               class="btn_carIcon"-->
<!--               @click="link(1)">-->
<!--          <div>首页</div>-->
<!--        </div>-->
<!--        <div class="flexOne">-->
<!--          <img src="@/assets/img/tabbar_health_nor.png"-->
<!--               alt=""-->
<!--               class="btn_carIcon"-->
<!--               @click="link(2)">-->
<!--          <div>档案</div>-->
<!--        </div>-->
<!--        <div class="flexOne">-->
<!--          <img src="@/assets/img/tabbar_shoppingmall_sel.png"-->
<!--               alt=""-->
<!--               class="btn_carIcon">-->
<!--          <div>商城</div>-->
<!--        </div>-->
<!--        <div class="flexOne">-->
<!--          <img src="@/assets/img/tabbar_account_nor_nor.png"-->
<!--               alt=""-->
<!--               class="btn_carIcon"-->
<!--               @click="link(4)">-->
<!--          <div>我的</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>
<script>
import { setOpenId, setCityName, setDistrict, removeUser, getToken, setToken, setUid, setIsSystem, removeToken, getCode, getUid, removeCode, removeUid } from 'utils/auth'
import { CODE_OK } from 'utils/publicData'
import Is from 'is_js'
import { browserEnvironment, linkApp, isWeixin, isApplet, getUrlStarParams } from 'utils/index'
import EnvionmentVariables from '../../../../baseUrl'
import { getLodop } from "../../../utils/LodopFuncs";
import Cookies from 'js-cookie';
const wx = require('weixin-js-sdk'); // 导入模块
export default {
  name: 'todayActivity',
  components: {
  },
  data () {
    return {
      infoType: [
        {
          create_time: 1593769201,
          id: 15,
          name: "一体机",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "额温枪",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "心电图",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "常规检查",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "血压计",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "体温计",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "血糖仪",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "血脂仪器",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "尿酸仪器",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "肝功能",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "糖尿病",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        },
        {
          create_time: 1593769201,
          id: 15,
          name: "血常规",
          num: 11,
          sort: 16,
          status: 1,
          update_time: 1594132929
        }
      ],
      active: 0,
      baseImg: EnvionmentVariables.IMAGE_HOST,
      goodsList: [
      ],
      tabAct: false,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 6, // 每页请求的数量
      total: 0, // 总共的数据条数
      // child: 6,
      // id: 11,
      // name: "疾病百科"
      child: 0,
      id: 31,
      name: "疫苗百科",
      loadingImges: {},
      k800: 0
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background: #fff');
  },
  created () {
    var token = this.$route.query.appToken;
    console.log("token");
    console.log(token);
    var openId = this.$route.query.openId;
    // var cityName = this.$route.query.cityName;
    // var district = this.$route.query.district;
    // var cityName = "深圳市";
    // var district = "南山区";
    // console.log("cityName");
    // console.log(cityName)
    // console.log("district");
    // console.log(district)
    // setCityName(cityName)
    // setDistrict(district)
    if (token) {
      console.log("token：" + token)
      setToken(token);
    }
    if (openId) {
      setOpenId(openId);
    }

    // if (this.$route.query.test) {
    //   alert("接收到了MVC传过来的参数");
    //   console.log("接收到了MVC传过来的参数")
    // }
    if (getUrlStarParams('k800')) {
      this.k800 = parseInt(getUrlStarParams('k800'))
    }
  },
  mounted () {
    var that = this;
    // this.$nextTick(() =>{
    //   setTimeout(() => {
    //     that.$refs.viewBox.scrollLeft = that.$refs.viewBox.scrollWidth / this.infoType.length * (that.tabIndex - 1);
    //   }, 500);
    //   this.$refs.viewBox.addEventListener('scroll', this.scroll);
    // })
    // window.addEventListener('scroll', this.handleScroll)
    this.getGoodList();
  },
  methods: {
    activityLoad (imgId, imgIndex) {
      console.log(111)
      if (imgId) {
        this.loadingImges[imgIndex] = true;
        this.$forceUpdate();
      }
    },
    btnClickPrint () {

    },
    link (type) {
      switch (type) {
        case 1:
          this.toHome()
          break;
        case 2:
          this.toFile()
          break;
        case 4:
          this.toMine()
          break;
      }
    },
    toMine () {
      let that = this
      let options = {
        token: this.token,
        appletHasToken: () => {
          let xcxUrl = '/pages/mine/mine'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        appletNoToken: () => {
          let xcxUrl = '/pages/mine/mine'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        weiXinHasToken: () => {
        },
        weiXinNoToken: () => {
        },
        iphoneHasToken: () => {
          let appParams = {
            pageType: 'gomine'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        iphoneNoToken: () => {
          let appParams = {
            pageType: 'gomine'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidHasToken: () => {
          let appParams = {
            pageType: 'gomine'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidNoToken: () => {
          let appParams = {
            pageType: 'gomine'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        browserHasToken: () => {
        },
        browserNoToken: () => {
        }
      };
      browserEnvironment(options)
    },
    toFile () {
      let that = this
      let options = {
        token: this.token,
        appletHasToken: () => {
          let xcxUrl = '/pages/archives/archives'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        appletNoToken: () => {
          let xcxUrl = '/pages/archives/archives'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        weiXinHasToken: () => {
        },
        weiXinNoToken: () => {
        },
        iphoneHasToken: () => {
          let appParams = {
            pageType: 'gofile'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        iphoneNoToken: () => {
          let appParams = {
            pageType: 'gofile'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidHasToken: () => {
          let appParams = {
            pageType: 'gofile'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidNoToken: () => {
          let appParams = {
            pageType: 'gofile'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        browserHasToken: () => {
        },
        browserNoToken: () => {
        }
      };
      browserEnvironment(options)
    },
    toHome () {
      let that = this
      let options = {
        token: this.token,
        appletHasToken: () => {
          let xcxUrl = '/pages/index/index'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        appletNoToken: () => {
          let xcxUrl = '/pages/index/index'
          wx.miniProgram.switchTab({ url: xcxUrl })
        },
        weiXinHasToken: () => {
        },
        weiXinNoToken: () => {
        },
        iphoneHasToken: () => {
          let appParams = {
            pageType: 'gohome'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        iphoneNoToken: () => {
          let appParams = {
            pageType: 'gohome'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidHasToken: () => {
          let appParams = {
            pageType: 'gohome'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        androidNoToken: () => {
          let appParams = {
            pageType: 'gohome'
          }
          linkApp(appParams, '', appParams.pageType)
        },
        browserHasToken: () => {
        },
        browserNoToken: () => {
        }
      };
      browserEnvironment(options)
    },
    healthCenter () {
      this.$router.push({ path: '/healthCenter', query: {} });
    },
    encyclopediaList () {
      // 有二级和无二级的区分
      // 有二级
      this.child = 0
      if (this.child && this.child > 0) {
        this.$router.push({
          path: "/wikiEncyDetails",
          query: {
            ...this.$route.query,
            // pid: this.id,
            pid: 11,
            title: encodeURIComponent(this.name)
          }
        });
      } else {
        this.$router.push({
          path: "/encyclopediaList",
          query: {
            ...this.$route.query,
            pid: 31,
            title: encodeURIComponent(this.name)
          }
        });
      }
    },
    address () {
      this.$router.push({ path: '/addressManage', query: {} });
    },
    order () {
      this.$router.push({ path: '/order', query: {} });
    },
    shopCart () {
      this.$router.push({ path: '/shopCart', query: {} });
    },
    goodDetail (item) {
      this.$router.push({ path: '/goodDetails', query: { id: item.id, k800: this.k800 } });
    },
    goSearch () {
      this.$router.push({ path: '/search', query: {k800: this.k800} });
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector('#tab').offsetTop;
      if (scrollTop >= offsetTop) {
        document.querySelector('#appNav').style.position = 'fixed';
        document.querySelector('#appNav').style.top = '0px';
      } else {
        document.querySelector('#appNav').style.position = 'absolute';
      }
    },
    toggle (index, item) {
      this.active = index;
      this.tabIndex = index;
      this.goodsList = [];
      this.pageIndex = 1;
      this.tabAct = true;
      this.article_type = item.id;
      this.isDownLoading = true;
      this.getGoodList(item.id);
      this.pageShow = true;
      this.$nextTick(() => {
        if (index == 0 || index == 1) {
          this.$refs.viewBox.scrollLeft = 0;
        }
        if (index >= 2) {
          this.$refs.viewBox.scrollLeft = this.$refs.viewBox.scrollWidth / this.infoType.length * (index - 1);
        }
      })
    },
    scroll () {
      this.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
    },
    // 获取商品列表
    getGoodList (article_type) {
      var that = this;
      var param = {
        service: "appagg",
        // service: "knowledge",
        query: {
          // agencyID: 56,
          // categoryId: 31,
          // searchKey: ""
          name: ''
        },
        pageIndex: that.pageIndex,
        pageSize: that.pageSize
      }
      this.$api.GetGoodsByPage(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.total = res.data.rows;
            // 数据全部加载完成
            if (that.goodsList.length >= that.total) {
              that.upFinished = true; // 加载结束
            } else {
              that.goodsList = that.goodsList.concat(res.data.result);
            }
            if (res.data.result.length < that.pageSize) {
              that.upFinished = true;
            }
          }
        }
      }).catch(err => {
      }).finally(() => {
        this.isDownLoading = false;
        this.isUpLoading = false;
      });
    },
    // 下拉刷新.
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.goodsList = [];
        this.upFinished = false // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getGoodList(this.article_type); // 加载数据
        this.timer = null // 清空定时器
      }, 300)
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getGoodList(this.article_type);
    }
  },
  // 在页面离开时记录滚动位置
  beforeRouteLeave (to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next()
  },
  // 进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.body.scrollTop = vm.scrollTop
    })
  }
}
</script>

<style scoped lang="less">
.salesVolume {
  margin-top: 40px;
  color: #b1b1b2;
  font-size: 28px;
}
.imgBox {
  width: 220px;
  height: 260px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.03);
  margin-right: 32px;
}
.imgBox img {
  width: 100%;
}
.linePo {
  height: 26px;
  width: 100%;
  background: #f8f8f8;
}
/deep/ .allPart {
  /*padding-top: 1.2rem;*/
  background: #f8f8f8;
}
.Router {
  height: 100%;
}
.commonPadding {
  height: 100%;
}
.buyBtn {
  background: url("../../../assets/img/buyBg.png") no-repeat;
  background-size: contain;
  width: 210px;
  height: 50px;
  line-height: 50px;
  margin: auto;
  text-align: center;
  font-weight: bold;
  font-size: 29px;
  margin-top: 24px;
}
.priceValue {
  font-size: 40px;
  font-weight: bold;
}
.pricePart {
  color: #ff3e29;
  font-size: 24px;
  margin-top: 26px;
}
.pro_sku {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 400px;
  line-height: 1.3;
  color: #3e3e3e;
  font-size: 32px;
  font-weight: bold;
}
.box {
  padding: 32px;
  box-sizing: border-box;
  width: 100%;
}
.newsUl {
  /*padding: 20px 0px;*/
  width: 100%;
  box-sizing: border-box;
}
.occupie {
  height: 98px;
}
.bottomTab {
  width: 100%;
  height: 96px;
  position: fixed;
  bottom: 0;
  background: #fff;
  font-size: 20px;
  color: #d0d6e6;
  text-align: center;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
}
.btn_carIcon {
  width: 56px;
  height: 56px;
}
.bottomTab .btn_carIcon {
  padding-top: 6px;
}
.bgShop {
  /*background: url("../../../assets/img/shop_bg.png") repeat-y;*/
  /*background-color: #FA1E28;*/
  /*padding-top: 1.2rem;*/
  background: #f8f8f8;
}
.desc {
  font-size: 26px;
  height: 60px;
  font-weight: bold;
}
.proName {
  font-size: 30px;
  height: 80px;
  font-weight: bold;
}
.imgPic {
  width: 230px;
  height: 212px;
  display: block;
  margin: 0px auto;
  border-radius: 10px;
}
li.actLi {
  width: 100%;
  float: left;
  /*padding: 0px 20px;*/
  /*margin-top: 40px;*/
  box-sizing: border-box;
  color: #ffeca4;
  font-size: 24px;
  /*background: url("../../../assets/img/boxBg.png") no-repeat;*/
  /*background-size: 100%;*/
  /*height: 300px;*/
  padding: 0 12px;
  margin: 8px 0;
}
li.actLi > .box{
  background: #fff;
  border-radius: 12px;
}
.search_icon {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}
.s_input {
  position: relative;
}
.searchInput {
  /*border: 1px solid #d1d1d1;*/
  border-radius: 32px;
  padding-left: 90px;
  padding-top: 0;
  padding-bottom: 0;
  height: 64px;
  line-height: 64px;
  background: #f5f5f5;
}
.inputTopWrap {
  height: 90px;
  width: 100%;
}
.inputTop {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
  /*background: linear-gradient(90deg, #FF202B 0%, #FF4E20 100%);*/
  /*box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.24);*/
  padding-bottom: 30px;
  padding-left: 29px;
  /*padding-right: 29px;*/
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid #f8f8f8;
}
.flex {
  display: flex;
}
.flexOne {
  flex: 1;
}
.carIcon {
  width: 96px;
  height: 96px;
  margin: auto;
  display: inline-block;
}
.car {
  width: 96px;
  text-align: right;
}
.noAct {
  width: 356px;
  height: 282px;
  display: block;
  margin: 5rem auto 42px;
}
.actText {
  font-size: 33px;
  text-align: center;
  color: #3E3E3E;
}
.topNav {
  width: 100%;
  //position: fixed;
  box-sizing: border-box;
  height: 88px;
  line-height: 88px;
  top: 0;
  z-index: 1000;
}
#tab {
  position: relative;
  height: 88px;
}
#appNav {
  width: 100%;
  height: 88px;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff1f0;
}
#appNav nav {
  padding: 0 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: middle;
  -ms-flex-align: middle;
  align-items: middle;
  overflow: auto;
}
#appNav p {
  text-align: center;
  font-size: 28px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding: 0px 50px;
  height: 100%;
  position: relative;
}
#appNav p.active {
  color: #e52317;
}
#appNav p.active::after {
  content: "";
  display: block;
  position: absolute;
  width: 45px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 4px;
  background: #e52317;
  border-radius: 2px;
}
#appNav p.active[data-v-1258668a] {
  color: #e52317;
}
</style>
